<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Изменить LCD Настройки (RV-3434)</v-list-item-title>
      <v-list-item-subtitle class="text-wrap mt-1">
        Быстрая загрузка по выбранным в таблице.
        <a href="#" class="primary--text" @click.prevent="$emit('redirect-new-page')">Расширенная страница</a>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="dialogLsdSettings" persistent max-width="520" content-class="dialog-border-radius">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" :disabled="!showSelectButton" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Изменить LCD Настройки (RV-3434)</v-card-title>
          <v-col cols="12" class="py-0">
          <v-autocomplete
            flat
            :items="LCD"
            v-model="welcomeDisplay"
            item-text="type"
            readonly
            item-value="welcome_display"
            label="Заставка"
            outlined
            dense
          ></v-autocomplete>
          </v-col>
          <v-col v-if="displayMassage" cols="12" class="py-0">
            <v-text-field
              label="Сообщение"
              v-model='message'
              counter="50"
              outlined
              dense
              flat
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="displayImg" cols="12" class="py-0">
            <v-file-input
              v-model='imageFile'
              ref="image"
              accept=".bmp"
              outlined
              hint="Формат файла bmp, 320х200 пикселей, 256 цветов"
              persistent-hint
              dense
              flat
              label="Изображение"
            >
            </v-file-input>
          </v-col>
          <mass-schedule-fields v-model="schedule" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="cancel"
              :loading="loading"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              class="text-none"
              @click="updateLsdSettings"
              :loading="loading"
              :disabled="loading || !isScheduleReady || !canSubmit"
            >
              Установить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500" content-class="dialog-border-radius">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="resultPrimaryMessage">
              <h3>{{ resultPrimaryMessage }}</h3>
            </v-col>
            <v-col v-if="queuedNotice">
              <p class="body-1 mb-0 mt-2">{{ queuedNotice }}</p>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';
import { LCD } from '@/components/doorphone/EditDoorphone/consts';
import MassScheduleFields from '@/components/massFunction/components/MassScheduleFields.vue';
import { buildSchedulePayload } from '@/components/massFunction/utils/schedulePayload';

export default {
  name: 'SettingsLsd',
  components: { MassScheduleFields },
  props: ['doorphones'],
  data () {
    return {
      dialogResult: false,
      dialogLsdSettings: false,
      welcomeDisplay: 3,
      imageFile: null,
      message: '',
      loading: false,
      updateResult: {},
      LCD,
      schedule: {
        useSchedule: false,
        startDate: '',
        endDate: '',
      },
    };
  },
  watch: {
    dialogLsdSettings (open) {
      if (open) {
        this.resetSchedule();
      }
    },
  },
  computed: {
    showSelectButton () {
      return this.doorphones.every(item => item.model_id === 5);
    },
    displayMassage () {
      return this.welcomeDisplay === 1;
    },
    displayImg () {
      return this.welcomeDisplay === 3;
    },
    isScheduleReady () {
      if (!this.schedule || !this.schedule.useSchedule) return true;
      return !!(this.schedule.startDate && this.schedule.endDate);
    },
    canSubmit () {
      if (!this.displayImg) return false;
      return !!this.imageFile;
    },
    resultPrimaryMessage () {
      const r = this.updateResult;
      if (!r) return '';
      if (r.mass_upload_id) {
        return `Задача поставлена в фон (${r.mass_upload_id}). Прогресс — в уведомлениях.`;
      }
      return r.message || r.success_message || '';
    },
    queuedNotice () {
      const r = this.updateResult;
      if (!r || !r.queued) return '';
      return 'Задача стоит в очереди и начнётся после завершения предыдущих загрузок изображения.';
    },
  },
  methods: {
    ...mapActions({
      updateMassLsdSettings: 'Doorphone/updateMassLsdSettings',
    }),
    resetSchedule () {
      this.schedule = {
        useSchedule: false,
        startDate: '',
        endDate: '',
      };
    },
    updateLsdSettings () {
      if (this.doorphones.length > 1000) {
        this.$flash_warning('Можно выбрать не более 1000 домофонов. Используйте расширенную страницу.');
        return;
      }
      const { payload, error } = buildSchedulePayload(this.schedule);
      if (error) {
        this.$flash_warning(error);
        return;
      }
      this.loading = true;
      const formData = new FormData();
      if (Array.isArray(this.doorphones) && this.doorphones.length > 0) {
        this.doorphones.forEach(d => {
          if (d.id) {
            formData.append('doorphones[]', d.id);
          }
        });
      }
      formData.append('welcome_display', 3);
      if (this.imageFile instanceof File) {
        formData.append('image', this.imageFile);
      }
      if (payload) {
        if (payload.start_date) {
          formData.append('start_date', payload.start_date);
        }
        if (payload.end_date) {
          formData.append('end_date', payload.end_date);
        }
      }

      this.updateMassLsdSettings(formData)
        .then((res) => {
          this.updateResult = res || {};
          this.dialogResult = true;
        })
        .catch((err) => {
          const message = err?.response?.data?.message || err?.response?.data?.error;
          if (message) {
            this.$flash_warning(message);
          }
          console.error(err);
        })
        .finally(() => {
          this.cancel();
        });
    },
    cancel () {
      this.dialogLsdSettings = false;
      this.loading = false;
      this.imageFile = null;
      this.message = null;
      this.resetSchedule();
    },
  },
};
</script>

<style scoped>

</style>
